import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { DragLayerMonitor, useDragLayer } from 'react-dnd'
import  {ReactComponent as UserIconLogo} from '../../../assets/svgs/user.svg'
import  {ReactComponent as Deleteiconlogo} from '../../../assets/svgs/delete.svg'

interface DraggingTransferProps {
    name: string,
    adjustForTransferRequest: boolean,
    Draglocation:string|null,
    selectedLocationId:string|null,
}

const useStyles = makeStyles(() => ({
    icon: {
        width: 30,
        height: 30,
        background: '#F4B827',
        padding: 10,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    nameLabel: {
        color: '#F4B827',
        fontSize: 12
    }
}));


const DraggingTransfer: React.FC<DraggingTransferProps> = ({
    name,
    adjustForTransferRequest,
    Draglocation,
    selectedLocationId
}) => {
    const classes = useStyles();
    const [requiredOffset, setRequiredOffset] = React.useState(0);
    const [requiredOffsetY, setRequiredOffsetY] = React.useState(0);

    const { isDragging, currentOffset, item, offset } = useDragLayer(
        (monitor: DragLayerMonitor) => {
            return {
                isDragging: monitor.isDragging(),
                currentOffset: monitor.getSourceClientOffset(),
                item: monitor.getItem(),
                offset: monitor.getClientOffset()
            };
        }
    );
    React.useEffect(() => {
        // adjust small icon position for long row
        
        if (adjustForTransferRequest) {
            if (isDragging) {

                setRequiredOffset(((offset?.x) ?? 0));
                setRequiredOffsetY(-10);
            }
            else {
                setRequiredOffsetY(0);
                setRequiredOffset(0);
            }
        }


    }, [isDragging]);

    // if(isDragging && currentOffset.y > 300){
    //     
    // }
    return (
        isDragging && currentOffset
            ? <div style={{
                // functional
                transform: `translate(${currentOffset.x + requiredOffset}px, ${currentOffset.y + requiredOffsetY}px)`,
                position: 'fixed',
                zIndex: 9999,
                top: 0,
                left: 0,
                pointerEvents: 'none',
                overflow: "overlay"
            }} className={classes.container}>
                <div>
                    {Draglocation === selectedLocationId || Draglocation === null?
                    <UserIconLogo style={{ borderRadius: 5, }} className={classes.icon} />
                    :
                    <Deleteiconlogo style={{ borderRadius: 5, }} className={classes.icon} />
                      }
                </div>
                <div className={classes.nameLabel}>
                    {name}
                </div>
            </div> : null
    );
}
export default React.memo(DraggingTransfer);